import Thumbnail from './thumbnail.png';

const title = 'Half-edge Mesh Operations';
const description = `Basic mesh operations implemented in C++ using a half-edge data structure.`;

export default {
  title,
  description,
  thumbnail: Thumbnail,
};
